import React, { useState } from 'react';
import './MetaKeysCategories.css'
import NavBar, { Item } from '../NAVIGATION/NavBar/NavBar';
import MetaKeysCategory from './MetaKeysCategory';
import CustomMetakeys from './CustomMetakeys';
import { appDataStore } from '_STORES/AppData';
import { MetaKeySources, Variable as VariableType } from 'Types';
import { translate } from 'translation';
import AddFreeField from './AddFreeField';
import VariableList from '_COMPONENTS/LOGICBLOCK/VariableList';
import { classNames } from 'utils/helpers';

interface Props {
    source?: MetaKeySources
    onSelect: (variables: VariableType[]) => void
}

export default function MetaKeysCategories({ onSelect, source }: Props) {
    const [currentCategory, setCurrentCategory] = useState<Item | null>(null)
    const [variables, setVariables] = useState<VariableType[]>([])

    const selectVariables = () => {
        onSelect && onSelect(variables)
    }

    const addVariable = (variable: VariableType) => {
        setVariables(prv => {
            // if (variable.value !== prv[prv.length - 1]?.value) {
            return [...prv, variable]
            // } else {
            //     return prv
            // }
        })
    }

    const navBar = [
        {
            label: "Free text",
            onClick: setCurrentCategory,
            active: false,
            value: <AddFreeField onSelect={addVariable} />
        },
        ...appDataStore.appData.CONSTANTES.W2PCIFW_META_KEYS
            .filter(category => !source
                ? true
                : category.allowedSource.includes(source)
            )
            .map((category, index) => ({
                label: category.label,
                active: index === 0,
                onClick: setCurrentCategory,
                value: <MetaKeysCategory category={category} onSelect={addVariable} />
            })),
        {
            label: "Custom meta_key",
            onClick: setCurrentCategory,
            active: false,
            value: <CustomMetakeys onSelect={addVariable} source={source} />
        }
    ]

    return (
        <div className='relative flex flex-col h-full meta-keys-container'>
            <NavBar
                items={navBar}
            />
            <div className={
                classNames(
                    'flex-1 -auto p-2 max-h-[600px]',
                    currentCategory?.label === "Custom meta_key" ? "" : "overflow-y-auto",
                )}
            >
                {currentCategory ? currentCategory.value : null}
            </div>

            {
                variables.length
                    ? <div className='relative flex justify-between mt-4 pt-3 border-gray-300 border-t'>
                        <VariableList
                            variableArray={variables}
                            onUpdate={setVariables}
                        />
                        <button
                            onClick={selectVariables}
                            className='self-center m-l-10 strong-button'
                        >
                            {translate("Add")}
                        </button>
                    </div>
                    : null
            }
        </div >
    )

}